import { useContext } from 'react';

import { UnifiedDialogContext } from '../context-providers/UnifiedDialogContext';

export type { UpdateType } from '../context-providers/UnifiedDialogContext';

/**
 * Hook to track unread updates for customers.
 *
 * Tracks dialogue and activities updates separately, allowing for:
 * - Single dot indicator in customer list (hasUnread)
 * - Future: separate indicators on Dialog/Activities tabs
 *
 * @example
 * const { addUnread, markRead, hasUnread, sortWithUnreadFirst } = useUnifiedDialog();
 *
 * // When notification arrives for non-selected customer
 * addUnread(customerId, 'dialogue');
 *
 * // When user selects a customer
 * markRead(customerId);
 *
 * // Check if customer has unread updates
 * if (hasUnread(customerId)) { ... }
 *
 * // Sort customers with unread updates first
 * const sorted = sortWithUnreadFirst(customers);
 */
export const useUnifiedDialog = () => {
  return useContext(UnifiedDialogContext);
};
